export default __webpack_public_path__ + "static/media/file.d563bbb3.png";